import React from "react";
import styled from "styled-components";

const TeamSection = (props) => {
  const lang = props.lang;
  const [isMobile, setIsMobile] = React.useState(true);
  React.useEffect(() => {
    setIsMobile(
      typeof window !== "undefined" ? window.screen.width < 800 : true
    );
  }, []);

  return (
    <Wrapper id="team">
      <img
        src="/LLL.png"
        width="25"
        style={{ width: 25, objectFit: "cover" }}
      />

      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
          <div style={{ flex: 1 }} />
          <div
            style={{
              flex: 2,
              minWidth: 250,
              padding: "60px 20px 60px 20px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Row1 lang={lang} />
            <Row2 lang={lang} extraStyle={{ marginTop: 40 }} />
          </div>
          <div style={{ flex: 1 }} />
        </div>
        <Contact id="social" lang={lang} />
      </div>
      <img
        src="/RRR.png"
        width="25"
        style={{ width: 25, objectFit: "cover" }}
      />
    </Wrapper>
  );
};

function Contact(props) {
  const lang = props.lang;
  const [isMobile, setIsMobile] = React.useState(true);
  React.useEffect(() => {
    setIsMobile(
      typeof window !== "undefined" ? window.screen.width < 800 : true
    );
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        backgroundColor: "#4B4BFE",
      }}
      id="social"
    >
      {!isMobile && <div style={{ flex: 1 }} />}
      <div
        style={{
          flex: 4,
          minWidth: 300,
          padding: "60px 20px 60px 20px",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <h1 style={{ color: "white" }}>
          {lang === "tw" ? "聯絡我們" : "Contact"}
        </h1>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            marginTop: 60,
          }}
        >
          {!isMobile && (
            <div
              style={{ height: "100%", width: "2vw", backgroundColor: "black" }}
            ></div>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              width: "50%",
              minWidth: 200,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <img src="/mail.png" width="32" />
              <a
                href="mailto:contact+nft@revteltech.com"
                style={{
                  marginLeft: 20,
                  color: "white",
                  fontSize: isMobile ? "1.2em" : 28,
                }}
              >
                contact+nft@revteltech.com
              </a>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginTop: 20,
              }}
            >
              <img src="/web2.png" width="32" />
              <a
                href="https://www.revtel.tech"
                target="_blank"
                style={{
                  marginLeft: 20,
                  color: "white",
                  fontSize: isMobile ? "1.2em" : 28,
                }}
              >
                https://www.revtel.tech
              </a>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginTop: 20,
              }}
            >
              <img src="/fb2.png" width="32" />
              <a
                href="https://www.facebook.com/RevtelTech"
                target="_blank"
                style={{
                  marginLeft: 20,
                  color: "white",
                  fontSize: isMobile ? "1.2em" : 28,
                }}
              >
                {lang === "tw" ? "忻旅科技" : "RevtelTech"}
              </a>
            </div>
          </div>
          {!isMobile && (
            <div
              style={{ height: "100%", width: "2vw", backgroundColor: "black" }}
            ></div>
          )}
        </div>

        <div
          style={{
            backgroundColor: "white",
            marginTop: 60,
            height: 2,
            width: "100%",
          }}
        />

        <div
          style={{
            color: "white",
            marginTop: 60,
            height: 2,
            width: "100%",
            textAlign: "center",
            fontSize: 18,
          }}
        >
          COPYRIGHT ©RevtelTech ALL RIGHT RESERVED
        </div>
      </div>
      {!isMobile && <div style={{ flex: 1 }} />}
    </div>
  );
}

function Row1(props) {
  const lang = props.lang;
  const [isMobile, setIsMobile] = React.useState(true);
  React.useEffect(() => {
    setIsMobile(
      typeof window !== "undefined" ? window.screen.width < 800 : true
    );
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: !isMobile ? "row-reverse" : "column",
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img width="150" src="/team1.png" />
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: isMobile ? 20 : 0,
        }}
      >
        <div
          style={{
            boxShadow: "7px 30px 56px 0 #d9d9d9, inset 14px 97px 16px 0 #fff",
            padding: 10,
            backgroundColor: "white",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: isMobile ? "center" : "flex-start",
            borderRadius: 25,
          }}
        >
          <h1>{lang === "tw" ? "團隊經驗" : "Expience"}</h1>
          <div
            style={{ width: "100%", height: 2, backgroundColor: "#4B4BFE" }}
          />
          <div style={{ marginTop: 10 }}>
            {lang === "tw"
              ? "團隊具豐富開發經驗並非一般工作室，曾協作超過 60 個以上 Web2 及 Web3 產品顧問及開發"
              : "More than 60 projects/products design and development"}
          </div>
          <div style={{ marginTop: 10, color: "grey" }}>
            {lang === "tw"
              ? "合作過海外獨角獸、新創、上市櫃公司及政府 技術涵括 Web、APP、IoT、區塊鏈至系統 遍及電商、金融、展覽及文創等多個領域"
              : "Web / APP / IoT"}
          </div>
        </div>
      </div>
    </div>
  );
}

function Row2(props) {
  const lang = props.lang;
  const [isMobile, setIsMobile] = React.useState(true);
  React.useEffect(() => {
    setIsMobile(
      typeof window !== "undefined" ? window.screen.width < 800 : true
    );
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: !isMobile ? "row" : "column",
        ...props.extraStyle,
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img width="150" src="/team2.png" />
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: isMobile ? 20 : 0,
        }}
      >
        <div
          style={{
            boxShadow: "7px 30px 56px 0 #d9d9d9, inset 14px 97px 16px 0 #fff",
            padding: 10,
            backgroundColor: "white",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: isMobile ? "center" : "flex-start",
            borderRadius: 25,
          }}
        >
          <h1>WEB2</h1>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => window.open("https://www.revtel.tech/project/")}
          >
            {lang === "tw"
              ? "跨越超過 10 個產業領域的開發及整合經驗"
              : "More than 10 fields (finance, education, ...) devloping expiences"}{" "}
            <img src="/link.png" width="16" />
          </div>
          <div
            style={{
              width: "100%",
              height: 2,
              backgroundColor: "#4B4BFE",
              marginTop: 10,
              marginBottom: 10,
            }}
          />
          <h1>WEB3</h1>
          <div style={{}}>
            <p
              style={{ cursor: "pointer" }}
              onClick={() => window.open("https://www.nft-farm.app/")}
            >
              {lang === "tw"
                ? "生成式 NFT 素材產生器"
                : "NFT asset generating tool"}{" "}
              <img src="/link.png" width="16" />
            </p>
            <p
              style={{ cursor: "pointer" }}
              onClick={() =>
                window.open("https://www.bnext.com.tw/article/56598/inigma?")
              }
            >
              {lang === "tw" ? "區塊鏈冷錢包開發" : "cold wallet development"}{" "}
              <img src="/link.png" width="16" />
            </p>
            <p>
              {lang === "tw"
                ? "商業司智能商圈發幣系統"
                : "Smart business district cryptocurrency system"}
            </p>
            <p>
              {lang === "tw"
                ? "知名藝廊 NFT / Web3 轉型顧問開發"
                : "Consultant"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

const Wrapper = styled.div`
  display: flex;

  flex-direction: row;

  justify-content: flex-start;

  background-color: #f9f9f9;
`;

export default TeamSection;
